// TODO: retire this file

const {AT} = require("./ActionTypeConstants");
const {
	getSuccessActionValue,
	getFailActionValue,
} = require("./ActionTypeHelpers");

Object.entries(AT).forEach(([key, value]) => {
	exports[key] = value;
});

exports.getSuccessType = getSuccessActionValue;
exports.getFailType = getFailActionValue;
